/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
// Keep one-for-one with PowerAlpha's LeveredFinancingInputs Pydantic defaults (FIMO 4.0.0).
// The backend has no swap-rate default; 4.30% here is the form prefill only.
export const DEFAULT_LEVERED_FINANCING_INPUTS = {
    term_debt: {
        contracted_dscr: 1.3,
        merchant_dscr: 2,
        tenor_years: null,
        pv_merchant_sizing_years: 5,
        bess_merchant_sizing_years: 0,
        network_upgrade_reimbursements_in_cfads: false,
        swap_rate: 0.043,
        percent_swapped: 1,
        floating_base_rate: 0.01,
        base_margin: 0.01625,
        margin_step_up_rate: 0.00125,
        margin_step_up_frequency_years: 4,
        refinancing_fee_rate: 0.0125,
        refinancing_frequency_years: 7,
        refinancing_fee_amortization_years: 7,
        administration_fee_annual: 75_000,
        upfront_fee_rate: 0.0175,
        debt_service_reserve_lc_fee_rate: 0.01625,
        debt_service_reserve_months: 6,
        day_count_basis: 360,
    },
    construction: {
        minimum_sponsor_equity_percentage: 0.1,
        construction_security_upfront_fee_rate: 0.01,
        operational_security_upfront_fee_rate: 0.01,
        sponsor_equity_return_date: null,
        construction_facility: {
            margin: 0.01625,
            commitment_fee_rate: 0.00625,
        },
        tax_equity_bridge: {
            margin: 0.01625,
            commitment_fee_rate: 0.00625,
            upfront_fee_rate: 0.018,
            tax_equity_committed: false,
            commitment_date: null,
            uncommitted_advance_rate: 0.75,
            committed_advance_rate: 0.97,
            credit_transfer_price: 0.925,
        },
        equipment_facility: {
            margin: 0.035,
        },
    },
    tax_equity: {
        hurdle_rate: 0.09,
        tax_rate: 0.21,
        upfront_fee_rate: 0.0195,
        early_funding_percentage: 0.2,
        early_funding_months_before_cod: 3,
        flip_years: 10,
        income_allocation_pre_flip: 0.99,
        income_allocation_post_flip: 0.05,
        cash_allocation_pre_flip: 0.15,
        cash_allocation_post_flip: 0.05,
        paygo_rate: 0.25,
        paygo_accrual_months: 108,
        paygo_payment_month: 3,
        paygo_cfads_credit_percentage: 1,
        network_upgrade_reimbursements_to_sponsor: true,
        partnership_year_convention: 'calendar',
    },
    solver: {
        irr_tolerance: 0.000001,
        cash_tolerance: 1,
        price_tolerance: 0.01,
        construction_circularity_tolerance: 0.00001,
        maximum_iterations: 1_000,
    },
};
//# sourceMappingURL=defaults.js.map